/* ScentStation AU – Double buy box (v1.3)
   Renders the second-scent and refill-subscription add-ons from the config
   output by snippets/double-buy-box.liquid, and adds everything to the cart. */
(function () {
  'use strict';

  var DAY = 24 * 3600 * 1000;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function find(list, fn) { for (var i = 0; i < list.length; i++) if (fn(list[i])) return list[i]; return null; }
  function scentCode(t) { var m = String(t || '').match(/\b(\d{3})\b/); return m ? m[1] : null; }
  function ordinal(n) { var s = ['th', 'st', 'nd', 'rd'], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); }
  function planWeeks(p) {
    var s = (p.name || '') + ' ' + (p.options || []).join(' ');
    var m = s.match(/(\d+)\s*(?:weeks?|wks?)/i); if (m) return +m[1];
    m = s.match(/(\d+)\s*months?/i); if (m) return Math.round(+m[1] * 52 / 12);
    m = s.match(/(\d+)\s*days?/i); if (m) return Math.round(+m[1] / 7);
    return null;
  }
  function dateIn(weeks) {
    return new Date(Date.now() + weeks * 7 * DAY).toLocaleDateString('en-AU', { day: 'numeric', month: 'short' });
  }

  function init(root) {
    var cfg = JSON.parse(root.querySelector('[data-dbb-config]').textContent);
    var mount = root.querySelector('[data-dbb-mount]');
    var uid = root.id || ('dbb-' + Math.random().toString(36).slice(2));
    var base = cfg.root || '/';
    if (base.charAt(base.length - 1) !== '/') base += '/';

    var tpl = String(cfg.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    function money(cents, trim) {
      cents = Math.max(0, Math.round(cents));
      var whole = Math.floor(cents / 100), part = cents % 100;
      var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var amt = (trim && part === 0) ? w : w + '.' + (part < 10 ? '0' : '') + part;
      return tpl.replace(/\{\{\s*[a-z_]+\s*\}\}/i, amt);
    }

    var A = cfg.current;
    var refillVars = (cfg.refill && cfg.refill.variants) || [];
    function refillFor(d) {
      if (!d) return null;
      var r = d.refillVariant ? find(refillVars, function (v) { return v.id === d.refillVariant; }) : null;
      if (!r) {
        var c = scentCode(d.title);
        if (c) {
          var cands = refillVars.filter(function (v) { return v.available && scentCode(v.title) === c; });
          var singles = cands.filter(function (v) { return !/double|twin|\b2\s*x\b|\bx\s*2\b|pack|bundle/i.test(v.title); });
          if (singles.length) cands = singles;
          cands.sort(function (a, b) { return a.price - b.price; });
          r = cands[0] || null;
        }
      }
      return r && r.available ? r : null;
    }
    function shortName(d) { var c = scentCode(d.title); return c ? 'Scent ' + c : d.title; }

    var others = (cfg.diffusers || []).filter(function (d) { return d.id !== A.id && d.available && d.variant; });
    var planMap = {}, rawPlans = [];
    refillVars.forEach(function (v) {
      (v.planList || []).forEach(function (p) { if (!planMap[p.id]) { planMap[p.id] = true; rawPlans.push(p); } });
    });
    var plans = rawPlans.map(function (p) {
      var w = planWeeks(p);
      return { id: p.id, name: p.name, weeks: w, label: w ? w + (w === 1 ? ' week' : ' weeks') : p.name };
    }).sort(function (a, b) { return (a.weeks || 999) - (b.weeks || 999); });
    var defPlan = find(plans, function (p) { return p.weeks === cfg.defaultWeeks; }) || plans[Math.floor((plans.length - 1) / 2)] || null;
    var defB = find(others, function (d) { return d.id === cfg.defaultPair; }) || others[0] || null;
    var hasRefillA = !!refillFor(A);

    var state = {
      b: !!defB,
      bId: defB ? defB.id : null,
      r: hasRefillA,
      plan: defPlan ? 'sub' : 'once',
      planId: defPlan ? defPlan.id : null
    };

    /* ---------- Theme editor diagnostics (never shown to customers) ---------- */
    function diagnostics() {
      var out = [];
      if (cfg.version !== '1.3') out.push('The snippet file is an older version. Replace snippets/double-buy-box.liquid with v1.3.');
      else if (cfg.refillCollection && !cfg.refillCollectionFound && !refillVars.length) out.push('No collection found with the handle "' + cfg.refillCollection + '". Check refill_collection_handle in the Custom Liquid block.');
      else if (!cfg.refillCollection && !refillVars.length) out.push('No refill source set. Add refill_collection_handle: \'keep-them-full\' to the Custom Liquid block.');
      else if (!refillVars.length) out.push('The refill collection loaded but has no products available on the Online Store.');
      var code = scentCode(A.title);
      if (!code) out.push('This diffuser\u2019s title has no 3-digit scent number, so its refill can\u2019t be matched.');
      else if (refillVars.length) {
        var m = refillVars.filter(function (v) { return scentCode(v.title) === code; });
        if (!m.length) out.push('No refill title contains "' + code + '". Refills loaded: ' + refillVars.map(function (v) { return v.title; }).join('; '));
        else if (!m.some(function (v) { return v.available; })) out.push('The Scent ' + code + ' refill is sold out or unavailable.');
      }
      if (hasRefillA && !plans.length) out.push('Refills found, but none are in a subscription plan yet, so only One-time shows.');
      if (!out.length) return '';
      return '<div class="dbb-debug"><b>Theme editor check (customers don\u2019t see this)</b><br>' +
        out.map(esc).join('<br>') + '<br><small>Refill products loaded: ' + refillVars.length + '</small></div>';
    }

    /* ---------- Markup ---------- */
    var h = '';
    if (defB) {
      h += '<div class="dbb-card" data-card-b>' +
        (cfg.badge ? '<span class="dbb-badge">' + esc(cfg.badge) + '</span>' : '') +
        '<label class="dbb-head">' +
          '<input type="checkbox" class="dbb-sr" data-b-on>' +
          '<span class="dbb-check" aria-hidden="true"></span>' +
          '<span class="dbb-thumb" aria-hidden="true"><img data-b-img alt="" width="48" height="48" loading="lazy"></span>' +
          '<span class="dbb-head-text"><span class="dbb-title">Add a second scent</span><span class="dbb-sub" data-b-sub></span></span>' +
          '<span class="dbb-headprice" data-b-price></span>' +
        '</label>' +
        '<div class="dbb-body" data-b-body>' +
          '<label class="dbb-label" for="' + uid + '-b">Choose your second scent</label>' +
          '<select id="' + uid + '-b" class="dbb-select" data-b-select>' +
            others.map(function (d) { return '<option value="' + d.id + '">' + esc(d.title) + '</option>'; }).join('') +
          '</select>' +
          '<p class="dbb-hint" data-b-hint></p>' +
        '</div>' +
      '</div>';
    }
    if (hasRefillA) {
      h += '<div class="dbb-card" data-card-r>' +
        '<label class="dbb-head dbb-head--plain">' +
          '<input type="checkbox" class="dbb-sr" data-r-on>' +
          '<span class="dbb-check" aria-hidden="true"></span>' +
          '<span class="dbb-head-text"><span class="dbb-title">Keep them full: add refills</span><span class="dbb-sub" data-r-sub></span></span>' +
          '<span class="dbb-headprice" data-r-price></span>' +
        '</label>' +
        '<div class="dbb-body" data-r-body>' +
          '<p class="dbb-per" data-r-per></p>' +
          '<p class="dbb-label">How would you like them?</p>' +
          '<div class="dbb-plans" role="radiogroup">' +
            (defPlan ?
              '<label class="dbb-plan" data-plan-opt="sub"><input type="radio" class="dbb-sr" name="' + uid + '-plan" value="sub">' +
                '<span class="dbb-dot" aria-hidden="true"></span>' +
                '<span><span class="dbb-plan-title">Subscribe</span> <span class="dbb-save" data-save></span><span class="dbb-perks" data-perks></span></span>' +
                '<span class="dbb-plan-price"><span data-sub-price></span><s data-sub-was></s></span>' +
              '</label>' : '') +
            '<label class="dbb-plan" data-plan-opt="once"><input type="radio" class="dbb-sr" name="' + uid + '-plan" value="once">' +
              '<span class="dbb-dot" aria-hidden="true"></span>' +
              '<span><span class="dbb-plan-title">One-time</span></span>' +
              '<span class="dbb-plan-price" data-once-price></span>' +
            '</label>' +
          '</div>' +
          (plans.length ?
            '<div data-cadence>' +
              '<p class="dbb-label">Then deliver every</p>' +
              '<div class="dbb-seg" role="radiogroup" style="grid-template-columns: repeat(' + plans.length + ', 1fr)">' +
                plans.map(function (p) {
                  return '<label data-week-opt="' + p.id + '"><input type="radio" class="dbb-sr" name="' + uid + '-weeks" value="' + p.id + '"><span>' + esc(p.label) + '</span></label>';
                }).join('') +
              '</div>' +
              '<div class="dbb-track" data-track>' +
                '<div class="dbb-steps">' +
                  '<div class="dbb-step"><b>1</b><span>Today</span></div>' +
                  '<div class="dbb-step"><b>2</b><span data-t2></span></div>' +
                  '<div class="dbb-step"><b>3</b><span data-t3></span></div>' +
                  '<div class="dbb-step"><b data-s4>4</b><span data-t4></span></div>' +
                  '<div class="dbb-step dbb-step--gift"><b data-s5>5</b><span>Free diffuser</span></div>' +
                '</div>' +
                '<p data-track-copy></p>' +
              '</div>' +
            '</div>' : '') +
          '<p class="dbb-note" data-match></p>' +
        '</div>' +
      '</div>';
    }
    h += '<div class="dbb-order" aria-live="polite">' +
        '<div class="dbb-row"><span data-o-a></span><span data-o-a-price></span></div>' +
        '<div class="dbb-row" data-o-b-row><span data-o-b></span><span data-o-b-price></span></div>' +
        '<div class="dbb-row" data-o-r-row><span data-o-r></span><span data-o-r-price></span></div>' +
        '<div class="dbb-row"><span data-o-ship-label>Shipping</span><span data-o-ship></span></div>' +
        '<div class="dbb-row dbb-row--total"><span>Total today</span><span data-o-total></span></div>' +
        '<p class="dbb-nudge" data-nudge></p>' +
        '<div class="dbb-then" data-then></div>' +
      '</div>' +
      '<button type="button" class="dbb-cta" data-cta></button>' +
      '<p class="dbb-foot">Free shipping on orders over ' + money(cfg.freeThreshold, true) + ', or on 2 diffusers with a refill subscription. Refill subscriptions can be changed or cancelled from your account. Shipping is confirmed at checkout.</p>' +
      '<p class="dbb-error" data-error role="alert" hidden></p>';
    if (window.Shopify && window.Shopify.designMode) h += diagnostics();
    mount.innerHTML = h;

    function $(sel) { return root.querySelector(sel); }
    function set(sel, text) { var el = $(sel); if (el) el.textContent = text; }
    function html(sel, markup) { var el = $(sel); if (el) el.innerHTML = markup; }
    function show(sel, on) { var el = $(sel); if (el) el.hidden = !on; }

    if (defB) {
      $('[data-b-on]').checked = state.b;
      $('[data-b-select]').value = String(state.bId);
    }
    if (hasRefillA) {
      $('[data-r-on]').checked = state.r;
      var pr = root.querySelector('[name="' + uid + '-plan"][value="' + state.plan + '"]'); if (pr) pr.checked = true;
      if (state.planId) { var wr = root.querySelector('[name="' + uid + '-weeks"][value="' + state.planId + '"]'); if (wr) wr.checked = true; }
    }

    /* ---------- Pricing + render ---------- */
    function compute() {
      var B = state.b ? find(others, function (d) { return d.id === state.bId; }) : null;
      var lines = [refillFor(A)]; if (B) lines.push(refillFor(B));
      var rl = lines.filter(Boolean);
      var count = rl.length;
      var plan = find(plans, function (p) { return p.id === state.planId; });
      var isSub = state.plan === 'sub' && !!plan;
      var subC = rl.reduce(function (s, v) { return s + (plan && v.plans && v.plans[plan.id] != null ? v.plans[plan.id] : v.price); }, 0);
      var onceC = rl.reduce(function (s, v) { return s + v.price; }, 0);
      var refC = state.r ? (isSub ? subC : onceC) : 0;
      var secondDisc = !!(B && state.r && count === 2);
      var bPrice = B ? (secondDisc ? Math.min(cfg.secondPrice, B.price) : B.price) : 0;
      var subtotal = A.price + bPrice + refC;
      var isDouble = !!(B && state.r && isSub && count === 2);
      var overThreshold = subtotal >= cfg.freeThreshold - 5; /* rule set at threshold minus 5c */
      var ship = (isDouble || overThreshold) ? 0 : cfg.stdShipping;
      return {
        B: B, rl: rl, count: count, plan: plan, isSub: isSub, subC: subC, onceC: onceC, refC: refC,
        secondDisc: secondDisc, bPrice: bPrice, subtotal: subtotal, isDouble: isDouble,
        overThreshold: overThreshold, ship: ship, total: subtotal + ship,
        N: count === 2 ? cfg.rewardDouble : cfg.rewardSingle
      };
    }

    function render() {
      var c = compute();
      var B = c.B;

      /* Second scent */
      if (defB) {
        $('[data-card-b]').classList.toggle('is-on', state.b);
        show('[data-b-body]', state.b);
        var shownB = B || find(others, function (d) { return d.id === state.bId; });
        var img = $('[data-b-img]');
        if (shownB && shownB.image) { img.src = shownB.image; img.hidden = false; } else { img.hidden = true; }
        set('[data-b-sub]', state.b && B ? B.title : (state.r ? 'Just ' + money(cfg.secondPrice) + ' with refills' : 'Pick any scent from the range'));
        var bList = shownB ? shownB.price : 0;
        html('[data-b-price]', state.r && shownB && refillFor(shownB) ?
          money(Math.min(cfg.secondPrice, bList)) + '<small><s>' + money(bList) + '</s></small>' : money(bList));
        var hint;
        if (B && !refillFor(B)) hint = 'Refills aren\u2019t available for this scent yet, so the ' + money(cfg.secondPrice) + ' price doesn\u2019t apply.';
        else if (state.r) hint = 'Your second diffuser is ' + money(cfg.secondPrice) + ' when you add refills. One for each car, or one to rotate with the seasons.';
        else hint = 'Add refills below and your second diffuser drops to ' + money(cfg.secondPrice) + '.';
        set('[data-b-hint]', hint);
      }

      /* Refills */
      if (hasRefillA) {
        $('[data-card-r]').classList.toggle('is-on', state.r);
        show('[data-r-body]', state.r);
        var word = c.count + (c.count === 1 ? ' refill' : ' refills');
        var weeksTxt = c.plan && c.plan.weeks ? 'every ' + c.plan.weeks + ' weeks' : 'on your schedule';
        set('[data-r-sub]', state.r ? (c.isSub ? word + ' ' + weeksTxt : word + ', one-time') : 'Top up your diffusers so they never run dry');
        html('[data-r-price]', state.r ? money(c.isSub ? c.subC : c.onceC, c.isSub) + (c.isSub ? '<small>per delivery</small>' : '') : '');
        html('[data-r-per]', 'One refill per diffuser: <b>' + word + '</b> each delivery.');
        if (c.plan) {
          set('[data-save]', c.onceC > c.subC ? 'Save ' + Math.round((1 - c.subC / c.onceC) * 100) + '%' : '');
          set('[data-perks]', (c.count === 2 && B ? 'Free shipping on today\u2019s order. ' : '') +
            'Free diffuser every ' + ordinal(c.N) + ' delivery, you pick the scent. ' +
            (cfg.subShipping > 0 ? money(cfg.subShipping, true) + ' flat shipping after today. ' : '') + 'Skip or cancel anytime.');
          set('[data-sub-price]', money(c.subC, true));
          set('[data-sub-was]', c.onceC > c.subC ? money(c.onceC) : '');
        }
        set('[data-once-price]', money(c.onceC));
        root.querySelectorAll('[data-plan-opt]').forEach(function (el) { el.classList.toggle('is-on', el.getAttribute('data-plan-opt') === state.plan); });
        root.querySelectorAll('[data-week-opt]').forEach(function (el) { el.classList.toggle('is-on', +el.getAttribute('data-week-opt') === state.planId); });
        show('[data-cadence]', c.isSub);
        if (c.isSub && c.plan) {
          var w = c.plan.weeks || 0;
          set('[data-s4]', c.N === 5 ? '4' : '\u2026');
          set('[data-s5]', String(c.N));
          set('[data-t2]', w ? dateIn(w) : '');
          set('[data-t3]', w ? dateIn(w * 2) : '');
          set('[data-t4]', w && c.N === 5 ? dateIn(w * 3) : '');
          set('[data-track-copy]', 'Your first refills ship today with your diffuser' + (B ? 's' : '') + '. Your ' + ordinal(c.N) +
            ' delivery' + (w ? ', around ' + dateIn(w * (c.N - 1)) + ',' : '') + ' includes a free diffuser in the scent of your choice.');
          $('[data-track]').setAttribute('aria-label', 'Free diffuser with every ' + ordinal(c.N) + ' delivery');
        }
        var names = [shortName(A)]; if (B && refillFor(B)) names.push(shortName(B));
        set('[data-match]', (names.length > 1 ? 'Each refill matches its diffuser (' + names.join(' and ') + ').' : 'Your refill matches this diffuser (' + names[0] + ').') +
          ' Swap anytime' + (c.isSub ? ' from your account.' : '.'));
      }

      /* Order summary */
      set('[data-o-a]', shortName(A) + ' diffuser');
      set('[data-o-a-price]', money(A.price));
      show('[data-o-b-row]', !!B);
      if (B) { set('[data-o-b]', shortName(B) + ' diffuser' + (c.secondDisc ? ' (second diffuser price)' : '')); set('[data-o-b-price]', money(c.bPrice)); }
      show('[data-o-r-row]', state.r && c.count > 0);
      set('[data-o-r]', c.count + (c.count === 1 ? ' refill' : ' refills') + (c.isSub ? ' (first delivery)' : ''));
      set('[data-o-r-price]', money(c.refC));
      html('[data-o-ship]', c.ship === 0 ? '<span class="dbb-free">Free</span>' : money(c.ship));
      set('[data-o-ship-label]', c.isDouble && !c.overThreshold ? 'Shipping (free with 2 diffusers + refill subscription)' : 'Shipping');
      set('[data-o-total]', money(c.total));

      var nudge = '';
      if (c.ship > 0) {
        if (!B && state.r && c.isSub && defB) nudge = 'Add a second scent for ' + money(cfg.secondPrice) + ' and your whole order ships free.';
        else if (B && !state.r && hasRefillA) nudge = 'Add refills on subscription and your whole order ships free, with your second diffuser at ' + money(cfg.secondPrice) + '.';
        else if (!B && !state.r && defB && hasRefillA) nudge = 'Add a second scent and a refill subscription and your order ships free.';
        else nudge = 'Add ' + money(cfg.freeThreshold - c.subtotal) + ' more for free shipping.';
      }
      set('[data-nudge]', nudge); show('[data-nudge]', !!nudge);

      var showThen = state.r && c.isSub && c.plan;
      show('[data-then]', !!showThen);
      if (showThen) {
        set('[data-then]', 'Then ' + money(c.subC, true) + ' + ' + (cfg.subShipping > 0 ? money(cfg.subShipping, true) + ' ' : '') + 'shipping ' +
          (c.plan.weeks ? 'every ' + c.plan.weeks + ' weeks' : 'per delivery') + ' for your refills. Every ' + ordinal(c.N) + ' delivery includes a free diffuser.');
      }

      var cta = $('[data-cta]');
      if (!A.available) { cta.disabled = true; cta.textContent = 'Sold out'; }
      else if (!busy) { cta.disabled = false; cta.textContent = 'Add to cart: ' + money(c.total) + ' today'; }
    }

    /* ---------- Events ---------- */
    var busy = false;
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-b-on]')) state.b = t.checked;
      else if (t.matches('[data-b-select]')) state.bId = +t.value;
      else if (t.matches('[data-r-on]')) state.r = t.checked;
      else if (t.name === uid + '-plan') state.plan = t.value;
      else if (t.name === uid + '-weeks') state.planId = +t.value;
      else return;
      hideError();
      render();
    });

    function hideError() { show('[data-error]', false); }
    function showError(msg) { set('[data-error]', msg); show('[data-error]', true); }

    $('[data-cta]').addEventListener('click', function () {
      if (busy || !A.available) return;
      var c = compute();
      var items = [{ id: A.variant, quantity: 1 }];
      if (c.B) items.push({ id: c.B.variant, quantity: 1 });
      if (state.r) {
        c.rl.forEach(function (v) {
          var it = { id: v.id, quantity: 1 };
          if (c.isSub && v.plans && v.plans[c.plan.id] != null) it.selling_plan = c.plan.id;
          var same = find(items, function (x) { return x.id === it.id && x.selling_plan === it.selling_plan; });
          if (same) same.quantity += 1; else items.push(it);
        });
      }
      busy = true;
      var cta = $('[data-cta]'); cta.disabled = true; cta.textContent = 'Adding\u2026';
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          root.dispatchEvent(new CustomEvent('dbb:added', { bubbles: true, detail: { items: items } }));
          var dest = cfg.afterAdd === 'checkout' ? 'checkout' : 'cart';
          window.location.href = cfg.testCode
            ? base + 'discount/' + encodeURIComponent(cfg.testCode) + '?redirect=' + encodeURIComponent(base + dest)
            : base + dest;
        })
        .catch(function (err) {
          busy = false;
          showError((err && (err.description || err.message)) || 'Something went wrong adding to cart. Please try again.');
          render();
        });
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-dbb]:not([data-dbb-ready])').forEach(function (el) {
      el.setAttribute('data-dbb-ready', '');
      try { init(el); } catch (e) { console.error('Double buy box:', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
